import { NgModule } from '@angular/core';
import { IonAffix } from './directives/ion-affix';

@NgModule({
    declarations: [
        IonAffix
    ],
    exports: [
        IonAffix
    ]
})
export class IonAffixModule {
}
